import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Card from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Card';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import Typography from 'Components/UI/Typography';
import { USDCurrencyFullFormatter } from 'Helpers/Formats';
import { withStyles } from '@material-ui/core/styles';
import { Collapse } from '@mui/material';
import KeyValueVertical from 'Components/UI/HoldingCard/KeyValueVertical';

function HoldingCard({
  holdingResource, holdingClassificationColor, expandedByDefault, classes,
}) {
  const [expanded, setExpanded] = useState(expandedByDefault);
  const positiveReturn = parseFloat(holdingResource.attr('dollarGain')) >= 0;
  const currencyColor = positiveReturn ? 'secondary' : 'accentBlue';
  return (
    <Card className={classes.mobileCard} onClick={() => setExpanded(!expanded)}>
      <div className={classes.mobileCardHeader}>
        <div className={classes.mobileCardTicker}>
          <FiberManualRecordIcon style={{ color: holdingClassificationColor }} />
          <Typography
            className={classes.tickerCellText}
            variant="h6"
            color="primary"
            noWrap
            title={holdingResource.attr('ticker')}
          >
            {holdingResource.attr('ticker')}
          </Typography>
        </div>
        <Typography variant="h6" color={currencyColor}>{USDCurrencyFullFormatter.format(holdingResource.attr('currentValue'))}</Typography>
      </div>
      <Collapse in={expanded} mountOnEnter={false} className={classes.holdingDetails}>
        <div className={classes.keyValueRow}>
          <KeyValueVertical prompt={holdingResource.meta().field('quantity').attr('prompt')} value={holdingResource.attr('quantity')} />
          <KeyValueVertical prompt={holdingResource.meta().field('currentPrice').attr('prompt')} value={USDCurrencyFullFormatter.format(holdingResource.attr('currentPrice'))} />
          <KeyValueVertical prompt={holdingResource.meta().field('costBasisPerShare').attr('prompt')} value={USDCurrencyFullFormatter.format(holdingResource.attr('costBasis'))} />
          <KeyValueVertical prompt={holdingResource.meta().field('percentGain').attr('prompt')} valueColor={currencyColor} value={USDCurrencyFullFormatter.format(holdingResource.attr('dollarGain'))} />
        </div>
      </Collapse>
    </Card>
  );
}

HoldingCard.propTypes = {
  holdingResource: PropTypes.object.isRequired,
  holdingClassificationColor: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  expandedByDefault: PropTypes.bool,
};

HoldingCard.defaultProps = {
  expandedByDefault: false,
};
export default withStyles(theme => ({
  mobileCard: {
    margin: theme.spacing(0.5),
    padding: theme.spacing(2),
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'column',
  },
  mobileCardTicker: {
    display: 'flex',
    flexDirection: 'row',
  },
  mobileCardHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
  },
  holdingDetailsRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  keyValueRow: {
    paddingTop: theme.spacing(1),
    width: '100%',
    justifyContent: 'space-between',
    display: 'flex',
    flexDirection: 'row',
  },
  holdingDetails: {
    display: 'flex',
    flexDirection: 'column',
  },
}))(HoldingCard);
